import { configureStore } from '@reduxjs/toolkit';
import lifePlanReducer from './lifePlan/slice';

export const store = configureStore({
  reducer: lifePlanReducer
})
